module.exports = __webpack_public_path__ + "images/patterns/light/WaveSquare.82d3fa1bcc373d74c90e.svg";